import { authUser, signOut } from '../slices/auth'
import type { AuthResponse, LoginBody } from '../types'
import apiClient from './apiClient'

export const authApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation<AuthResponse, Record<string, unknown>>({
      query: (body) => ({
        url: '/users',
        method: 'POST',
        body,
      }),
    }),
    login: builder.mutation<AuthResponse, LoginBody>({
      query: (body) => ({
        url: '/authentication',
        method: 'POST',
        body: { strategy: 'local', ...body },
      }),
    }),
    reauthenticate: builder.mutation<AuthResponse, void>({
      query: () => ({
        url: '/authentication',
        method: 'POST',
        body: { strategy: 'jwt' },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(authUser({ accessToken: data.accessToken, user: data.user }))
        } catch {
          dispatch(signOut())
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const { useRegisterMutation, useLoginMutation, useReauthenticateMutation } = authApi
